import UserConverter from './UserConverter';

import { AuthUser } from '../../model/domain/AuthUser';
import { UserTO } from '../to/UserTO';

const toDomain = (userTO: UserTO) => {
  return {
    user: UserConverter.toDomain(userTO),
  } as AuthUser;
};

export default {
  toDomain,
};
